import type { Screen, ScreenId } from "./ScreenManager";
import { dicePips } from "./assets";
import { asset } from "../../platform/assets";

export class SplashScreen implements Screen {
  readonly id: ScreenId = "splash";

  private bar!: HTMLElement;
  private percent!: HTMLElement;
  private progress = 0;
  private timer = 0;

  render(): HTMLElement {
    const el = document.createElement("div");
    el.innerHTML = `
      <div class="splash__logo">
        <div class="splash__board-wrap">
          <img class="splash__board splash__board--logo"
               src="${asset("logo/game-logo.jpg")}" alt="Ludo game logo"/>
          <div class="dice dice--a">${dicePips([1, 5, 3])}</div>
          <div class="dice dice--b">${dicePips([2, 6, 4])}</div>
        </div>
        <h1 class="splash__title">Ludo</h1>
        <p class="splash__subtitle">NepLox Games</p>
      </div>
      <div class="splash__progress">
        <div class="splash__bar"><div class="splash__bar-fill"></div></div>
        <span class="splash__percent">0%</span>
      </div>
    `;
    this.bar = el.querySelector(".splash__bar-fill")!;
    this.percent = el.querySelector(".splash__percent")!;
    return el;
  }

  onEnter(): void {
    // Pick up where the HTML boot splash left off — no bar jump.
    const bootBar = document.getElementById("boot-bar") as HTMLElement | null;
    if (bootBar) {
      const w = parseFloat(bootBar.style.width) || 0;
      if (w > 5) this.progress = Math.min(95, w);
    }
    const step = () => {
      // ~3s total — smooth and premium, not rushed.
      const remaining = 100 - this.progress;
      this.progress = Math.min(100, this.progress + Math.max(1.2, remaining * 0.055));
      this.bar.style.width = `${this.progress}%`;
      this.percent.textContent = `${Math.round(this.progress)}%`;
      if (this.progress < 100) {
        this.timer = window.setTimeout(step, 80);
      }
    };
    step();
  }

  onExit(): void {
    window.clearTimeout(this.timer);
  }

  get done(): boolean {
    return this.progress >= 100;
  }
}
